import { Select, DatePicker, Space, Input, Button } from "antd";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import check from "../../../imgs/add.png";
import across from "../../../imgs/across.png";
import logo1 from "../../../imgs/logo12.png";
import moment from "moment";
import img from "../../../imgs/impLogo.png";
import { message } from "antd";
import { useEffect } from "react";
import deleteicon from "../../../imgs/bs3.png";
import { Nationalties } from "../Constants/constant";
import { Religion } from "../Constants/constant";
import { UnionStatus } from "../Constants/constant";
import { Ethnicity } from "../Constants/constant";
// import ContactPerson from "./ThirdStepContactPerson";
import { detectObjectsInImage } from "../../../utlis/modelLoader";
import FaceVerificatioNModal from "../../../utlis/FaceVerficationLoaderModal";
let file;
let rr;
const Mid = () => {
  const isGovernmentAgency=useSelector((state)=>state?.isGovernmentAgency)
  rr = Nationalties?.map((item) => {
    return {
      lable: `${item}`,
      value: `${item}`,
    };
  });

  useEffect(() => {
    if (!test) {
      setTest(true);
    } else {
      setTest(false);
    }
  }, []);
  const option = useSelector((state) => state.option);
  const [age1, setAge1] = useState("");
  const [show, setShow] = useState(false);
  const [showC, setShowC] = useState(false);
  const [display, setDisplay] = useState(
    "data:image/png;base64,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"
  );
  const [title, setTitle] = useState("");
  const [msg, setMsg] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const [buttonW, setButtonW] = useState("");
  const [buttonN, setButtonN] = useState(" Verify Again");
  const [pop, setPop] = useState("1");
  const [test, setTest] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [callName, setCallName] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [ethnicity, setEthnicity] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [unionStatus, setUnionStatus] = useState("");
  const [nationality, setNationality] = useState("Guyanese");
  const [religion, setReligion] = useState("");
  const [show1, setShow1] = useState(false);
  const [err, setErr] = useState("");
  const dispatch = useDispatch();
  const token = useSelector((state) => state.token);
  const [verify, setVerify] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [emails, setEmails] = useState([]);
  const [newEmail, setNewEmail] = useState("");
  const [homePhones, setHomePhones] = useState([]);
  const [newhomePhone, setNewHomePhone] = useState("");
  const [workPhones, setWorkPhone] = useState([]);
  const [newWorkPhone, setNewWorkPhone] = useState("");
  const [ownerDetailAdded, setOwnerDetailAdded] = useState(false);
  const [one, setOne] = useState(false);
  const [contactPeople, setContactPeople] = useState([
    {
      image: "",
      fullName: "",
      title: "",
      phones: [],
      emails: [],

      documents: [
        {
          type: "taxpayer identification",
          docIDName: "TIN Number",
          docIDValue: "",
          images: [],
        },
        {
          type: "national insurance",
          docIDName: "NIS Number",
          docIDValue: "",
          images: [],
        },
      ],
    },
  ]);
  const faceApi = useSelector((state) => state.faceApi);
  const [previousImage, setPreviousImage] = useState("");
  const [notHuman, setNotHuman] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const addhomePhone = () => {
    if (newhomePhone.trim() !== "") {
      setHomePhones([...homePhones, newhomePhone]);
      setNewHomePhone("");
    }
  };

  const removehomePhone = (index) => {
    const updatedhomePhones = [...homePhones];
    updatedhomePhones.splice(index, 1);
    setHomePhones(updatedhomePhones);
  };

  const handlehomePhoneChange = (e, index) => {
    const updatedhomePhones = [...homePhones];
    updatedhomePhones[index] = e.target.value;
    setHomePhones(updatedhomePhones);
  };

  const addWorkPhone = () => {
    if (newWorkPhone.trim() !== "") {
      setWorkPhone([...workPhones, newWorkPhone]);
      setNewWorkPhone("");
    }
  };

  const removeWorkPhone = (index) => {
    const updatedWorkPhones = [...workPhones];
    updatedWorkPhones.splice(index, 1);
    setWorkPhone(updatedWorkPhones);
  };

  const handleWorkPhoneChange = (e, index) => {
    const updatedWorkPhones = [...workPhones];
    updatedWorkPhones[index] = e.target.value;
    setWorkPhone(updatedWorkPhones);
  };

  const addEmail = () => {
    const emailFormatRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    if (newEmail.trim() !== "" && emailFormatRegex.test(newEmail)) {
      setEmails([...emails, newEmail]);
      setNewEmail("");
    } else {
      setErr("Please enter a valid email address");
      setShow1(true);
    }
  };

  const removeEmail = (index) => {
    const updatedEmails = [...emails];
    updatedEmails.splice(index, 1);
    setEmails(updatedEmails);
  };

  const handleEmailChange = (e, index) => {
    const updatedEmails = [...emails]; // Create a copy of the emails array
    updatedEmails[index] = e.target.value; // Update the value at the specified index
    setEmails(updatedEmails); // Update the state with the modified array
  };

  const handleChange = (setState, check) => (event) => {
    if (check === "tt") {
      if (event) {
        const birthDate = event.$d;
        var today = new Date();
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        setAge1(age);
        if (age === 64) {
          const tod = today.getMonth() + 1;
          const earl = birthDate.getMonth() + 1;
          const fil = tod - earl;

          if (12 - fil <= 3) {
          }
        }
        let wow;
        if (event.$M <= 9) {
          if (event.$D <= 9) {
            wow = `${event.$y}-0${Number(event.$M) + 1}-0${event.$D}`;
          } else {
            wow = `${event.$y}-0${Number(event.$M) + 1}-${event.$D}`;
          }
        } else {
          if (event.$D <= 9) {
            wow = `${event.$y}-${Number(event.$M) + 1}-0${event.$D}`;
          } else {
            wow = `${event.$y}-${Number(event.$M) + 1}-${event.$D}`;
          }
        }
        setDob(wow);
      } else if (event === null) {
        setAge1("");
      }
    } else if (check === "tg") {
      setState(event);
    } else {
      setState(event.target.value);
    }
  };

  const FaceError = () => {
    messageApi.open({
      // type: 'success',
      content: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={img} alt="mage" width="50" height="50" />
          <h3>
            Please upload your profile image again; it's not verified as a human
            face.
          </h3>
        </div>
      ),
      duration: 6,
    });
  };
  const calculateFileHash = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = async (e) => {
        const buffer = e.target.result;
        const cryptoKey = await crypto.subtle.digest("SHA-256", buffer);
        const hashArray = Array.from(new Uint8Array(cryptoKey));
        const hashHex = hashArray
          .map((byte) => byte.toString(16).padStart(2, "0"))
          .join("");
        resolve(hashHex);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    });
  };
  const imageHandler = async (e) => {
    const file = e.target.files[0];
    const newImageHash = await calculateFileHash(file);
    if (newImageHash === previousImage && notHuman === true) {
      FaceError();
      fileInputRef.current.value = null;
      return;
    }
    if (file) {
      dispatch({ type: "FACE_API", num: true });
      const detectedObjects = await detectObjectsInImage(file);
      // setObjects(detectedObjects);

      const hasHuman = detectedObjects.some(
        (object) => object.class === "person"
      );
      dispatch({ type: "FACE_API", num: false });
      if (hasHuman) {
        setNotHuman(false);
        imageUploder(e);
        console.log("The image contains a human.");
      } else {
        setNotHuman(true);
        setPreviousImage(newImageHash);
        FaceError();
        console.log("The image does not contain a human.");
      }
      fileInputRef.current.value = null;
    }
  };
  const imageUploder = async (e) => {
    file = e.target.files[0];
    const base641 = await convertToBase64(file);
    setDisplay(base641);
    var bodyFormData = new FormData();
    bodyFormData.append("file", file);

    axios({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}/v1/file/merchat-files?fileType=merchantOwnerProfilePic`,
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((data) => {
        setImageUrl(data.data.url);
      })
      .catch(() => {});
  };

  function convertToBase64(file) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  }
  const nextHandler = () => {
    // e.preventDefault();
    console.log("done");
    if (ownerDetailAdded === true) {
      if (
        contactPeople[0].fullName !== "" ||
        contactPeople[0].phones.length > 0 ||
        contactPeople[0].emails.length > 0 ||
        contactPeople[0].documents[0].docIDValue !== "" ||
        contactPeople[0].documents[1].docIDValue !== "" ||
        contactPeople[0].image !== ""
      ) {
        console.log("done1");
        ContactPersonValidation();
      }
    } else {
      console.log("done2");
      let body = {};
      body = {
        title,
        image: `${imageUrl}`,
        firstName,
        lastName,
        dateOfBirth: dob,
        gender,
        nationality,
      };
      if (religion) {
        body.religion = religion;
      }

      if (unionStatus) {
        body.unionStatus = unionStatus;
      }
      if (ethnicity) {
        body.ethnicity = ethnicity;
      }
      if (middleName) {
        body.middleName = middleName;
      }
      if (callName) {
        body.callName = callName;
      }
      if (homePhones.length > 0) {
        body.homePhones = homePhones;
      }
      if (workPhones.length > 0) {
        body.workPhones = workPhones;
      }
      if (emails.length > 0) {
        body.emails = emails;
      }

      axios
        .post(`${process.env.REACT_APP_BASE_URL}/v1/merch-person`, body, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((data) => {
          setOwnerDetailAdded(true);
          if (
            contactPeople[0].fullName !== "" ||
            contactPeople[0].phones.length > 0 ||
            contactPeople[0].emails.length > 0 ||
            contactPeople[0].documents[0].docIDValue !== "" ||
            contactPeople[0].documents[1].docIDValue !== "" ||
            contactPeople[0].image !== ""
          ) {
            ContactPersonValidation();
          } else {
            dispatch({ type: "IINCREMENT" });
            dispatch({ type: "data1Set", num: data });
            dispatch({
              type: "nameSet",
              num: `${data.data.firstName} ${data.data.lastName}`,
            });
            dispatch({
              type: "imageSet",
              num: `${data.data.image}`,
            });
          }
        })
        .catch((err) => {
          if (
            err.response.data.message === '"image" is not allowed to be empty'
          ) {
            setErr("Please uplaod a profile picture");
          } else if (
            err?.response?.data?.message === `"[0]" must be a valid email`
          ) {
            setErr("Enter valid owner email address");
          } else {
            setErr(err?.response?.data?.message);
          }
          setShow1(true);
        });
    }
  };

  const ContactPersonValidation = () => {
    let hasErrors = false;
    contactPeople.forEach((contactPerson) => {
      if (contactPerson.title === "") {
        setErr("Please enter title of contact person");
        setShow1(true);
        hasErrors = true;
      }
      if (contactPerson.fullName === "") {
        setErr("Please enter full name of contact person");
        setShow1(true);
        hasErrors = true;
      }
      if (contactPerson.phones.length === 0) {
        setErr("Please enter phone number of contact person");
        setShow1(true);
        hasErrors = true;
      }
      if (contactPerson.documents[0].docIDValue !== "") {
        if (contactPerson.documents[0].images.length === 0) {
          setErr("Please upload TIN document of contact person");
          setShow1(true);
          hasErrors = true;
        } else {
          contactPerson.documents[0].images.forEach((image) => {
            if (image === "") {
              setErr("Please upload TIN document of contact person");
              setShow1(true);
              hasErrors = true;
            }
          });
        }
      }
      if (contactPerson.documents[1].docIDValue !== "") {
        if (contactPerson.documents[1].images.length === 0) {
          setErr("Please upload NIS document of contact person");
          setShow1(true);
          hasErrors = true;
        } else {
          contactPerson.documents[1].images.forEach((image) => {
            if (image === "") {
              setErr("Please upload NIS document of contact person");
              setShow1(true);
              hasErrors = true;
            }
          });
        }
      }
    });

    if (!hasErrors) {
      AddContactPerson();
    }
  };

  const createCopyWithoutUrls = (originalArray) => {
    // Create a deep copy of the original array
    const newArray = JSON.parse(JSON.stringify(originalArray));

    // Iterate over each contact person and remove URLs from images
    newArray.forEach((contactPerson) => {
      // Remove image URLs
      if (contactPerson.image === "") {
        delete contactPerson.image;
      }
      if (contactPerson.title === "") {
        delete contactPerson.title;
      }
      if (contactPerson.fullName === "") {
        delete contactPerson.fullName;
      }
      if (contactPerson.phones.length === 0) {
        delete contactPerson.phones;
      }
      if (contactPerson.emails.length === 0) {
        delete contactPerson.emails;
      }
      if (contactPerson.image) {
        delete contactPerson.profileUrl;
      }

      if (contactPerson.documents) {
        // Use filter to create a new array without documents with empty docIDValue
        contactPerson.documents = contactPerson.documents.filter(
          (document) => document.docIDValue !== ""
        );

        // Iterate through the updated array
        contactPerson.documents.forEach((document, index) => {
          console.log(document);

          // Remove image URLs
          delete document.backurl;
          delete document.fronturl;
        });
      }
    });

    return newArray;
  };

  const AddContactPerson = () => {
    // Create a copy of contactPeople without URLs
    const contactPeopleCopy = createCopyWithoutUrls(contactPeople);

    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/v1/merch-contact-person`,
        contactPeopleCopy,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        dispatch({ type: "IINCREMENT" });
      })
      .catch((err) => {
        if (
          err.response.data.message === '"image" is not allowed to be empty'
        ) {
          setErr("Please uplaod a profile picture");
        } else if (
          err?.response?.data?.message === `"[0]" must be a valid email`
        ) {
          setErr("Enter valid contact person email address");
        } else {
          setErr(err?.response?.data?.message);
        }
        setShow1(true);
      });
  };

  function getCurrentDate(separator = "") {
    let newDate = new Date();
    let date_raw = newDate.getDate();
    let month_raw = newDate.getMonth() + 1;
    let year = newDate.getFullYear();
    var date, month;

    if (date_raw < 10) {
      date = "0" + date_raw.toString();
    } else {
      date = date_raw.toString();
    }
    if (month_raw < 10) {
      month = "0" + month_raw.toString();
    } else {
      month = month_raw.toString();
    }

    return (
      <div>
        {year}
        {separator}
        {month}
        {separator}
        {date}
      </div>
    );
  }
  const date1 = getCurrentDate();
  const disabledBeforeDate1 = moment(
    `${date1.props.children[0]}-${date1.props.children[2]}-${date1.props.children[4]}`
  );
  const disabledDate1 = (current) => {
    return current && current > disabledBeforeDate1;
  };

  return (
    <div>
      <form action="" className="mt-10 sm:mt-[5rem]" onSubmit={nextHandler}>
        {contextHolder}
        <div className="flex items-center justify-center mb-4 flex-col">
          <label htmlFor="special-input" className="cursor-pointer relative">
            <div className="relative w-[8.5rem] h-[8.5rem] overflow-hidden border-2 border-[#686262]  rounded-full mb-4 ">
              <img
                className="object-cover w-[8.5rem] h-[8.5rem]"
                src={display}
                alt=""
              />
            </div>

            <div
              className={`bg-primary
               rounded-full absolute bottom-4 right-2`}
            >
              <img src={check} className="lg:w-7 w-5" alt="" />
            </div>
            <input
              type="file"
              className="hidden"
              id="special-input"
              accept="image/png, image/gif, image/jpeg"
              onInput={imageHandler}
              ref={fileInputRef}
            />
          </label>
          <h2 className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
            Upload {isGovernmentAgency ? "Director" :"Business Owner"} Picture{" "}
            <span className="text-red-600">*</span>
          </h2>
        </div>
        <div className="flex justify-center items-center">
          <div className="grid sm:grid-cols-2 sm:gap-4 grid-cols-1 sm:w-[70%] w-[80%]">
            <div className="w-[100%]">
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Title <span className="text-red-600">*</span>
                </label>
                <Select
                  placeholder="Title"
                  optionFilterProp="children"
                  className="wow"
                  style={{ marginBottom: "1.2rem" }}
                  onChange={handleChange(setTitle, "tg")}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  size="middle"
                  options={[
                    {
                      value: "Mr.",
                      label: "Mr.",
                    },
                    {
                      value: "Mrs.",
                      label: "Mrs.",
                    },
                    {
                      value: "Miss.",
                      label: "Miss.",
                    },
                  ]}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  First Name <span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  onChange={handleChange(setFirstName)}
                  value={firstName}
                  placeholder="First Name"
                  className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Middle Name
                </label>
                <input
                  type="text"
                  onChange={handleChange(setMiddleName)}
                  value={middleName}
                  placeholder="Middle Name"
                  className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Last Name <span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  onChange={handleChange(setLastName)}
                  value={lastName}
                  placeholder="Last Name"
                  className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                />
              </div>

              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  AKA / Call Name
                </label>
                <input
                  type="text"
                  onChange={handleChange(setCallName)}
                  value={callName}
                  placeholder="AKA / Call Name"
                  className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Date of Birth <span className="text-red-600">*</span>
                </label>
                <DatePicker
                  style={{ marginBottom: "1.2rem" }}
                  disabledDate={disabledDate1}
                  className="date-class"
                  onChange={handleChange(dob, "tt")}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Age <span className="text-red-600">*</span>
                </label>
                <input
                  style={{ marginBottom: "1.2rem" }}
                  className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                  value={`${age1 === "" ? "" : `${age1} year`}`}
                  onChange={(value) => {
                    if (one && value < 16) {
                      setErrorMessage("Age must be at least 16 years.");
                    } else {
                      setErrorMessage("");
                    }
                  }}
                  placeholder="Age"
                />
                {errorMessage}
              </div>
            </div>
            <div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Gender <span className="text-red-600">*</span>
                </label>
                <Select
                  placeholder="Gender"
                  optionFilterProp="children"
                  className="wow"
                  style={{ marginBottom: "1.2rem" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  size="middle"
                  onChange={handleChange(setGender, "tg")}
                  options={[
                    {
                      value: "Male",
                      label: "Male",
                    },
                    {
                      value: "Female",
                      label: "Female",
                    },
                    {
                      value: "Non-Binary",
                      label: "Non-Binary",
                    },
                    {
                      value: "Transgender",
                      label: "Transgender",
                    },
                  ]}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Ethnicity <span className="text-red-600">*</span>
                </label>
                <Select
                  placeholder="Ethnicity"
                  optionFilterProp="children"
                  className="wow"
                  style={{ marginBottom: "1.1rem" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  size="middle"
                  onChange={handleChange(setEthnicity, "tg")}
                  options={Ethnicity}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Marital Status <span className="text-red-600">*</span>
                </label>
                <Select
                  placeholder="Marital Status"
                  optionFilterProp="children"
                  className="wow"
                  style={{ marginBottom: "1.1rem" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  size="middle"
                  onChange={handleChange(setUnionStatus, "tg")}
                  options={UnionStatus}
                />
              </div>

              <div className="flex flex-col">
                <label
                  
                  className="text-[#596F96] text-[0.88rem] font-semibold mb-2"
                >
                  Nationality <span className="text-red-600">*</span>
                </label>
                <Select
                  placeholder="Nationality"
                  showSearch
                  className="wow"
                  value={nationality}
                  onChange={handleChange(setNationality, "tg")}
                  optionFilterProp="children"
                  style={{
                    marginBottom: option === "Employee" ? "1rem" : "1.1rem",
                  }}
                  filterOption={(input, option) =>
                    (option?.lable ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  size="middle"
                  options={rr}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[#596F96] text-[0.88rem] font-semibold mb-2">
                  Religion <span className="text-red-600">*</span>
                </label>
                <Select
                  placeholder="Religion"
                  optionFilterProp="children"
                  className="wow"
                  style={{ marginBottom: "0.9rem" }}
                  onChange={handleChange(setReligion, "tg")}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  size="middle"
                  showSearch
                  options={Religion}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Other Contact Details */}
        <div className="flex justify-center items-center flex-col mt-4 mb-4">
          <h2 className="mb-4 text-[1rem] font-semibold text-[#596F96]">
            Contact Details <span className="text-red-600">*</span>
          </h2>
          <div className="grid sm:grid-cols-2 sm:gap-4 grid-cols-1 sm:w-[70%] w-[80%] gap-3">
            <div className="w-[100%]">
              <div className="flex flex-col">
                <Space.Compact
                  style={{
                    width: "100%",
                  }}
                >
                  <Input
                    placeholder="Home Phone"
                    type="tel"
                    value={newhomePhone}
                    className="p-2"
                    id="home"
                    autoComplete="on"
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      if (/^\+?[0-9()-]*$/.test(inputValue)) {
                        setNewHomePhone(inputValue);
                      }
                    }}
                  />
                  <Button className="bg-slate-300  h-12" onClick={addhomePhone}>
                    Add
                  </Button>
                </Space.Compact>

                {homePhones?.map((link, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between mt-2 p-2 bg-gray-200 shadow-md rounded-md border border-gray-300"
                  >
                    <Input
                      placeholder="Enter URL"
                      value={link}
                      className="bg-slate-200 mr-2"
                      onChange={(e) => handlehomePhoneChange(e, index)}
                    />

                    <button
                      type="button"
                      onClick={() => removehomePhone(index)}
                    >
                      <img src={deleteicon} alt="" className="w-6 h-6" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
            <div className="w-[100%]">
              <div className="flex flex-col">
                <Space.Compact
                  style={{
                    width: "100%",
                  }}
                >
                  <Input
                    placeholder="Work Phone"
                    value={newWorkPhone}
                    id="work"
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      if (/^\+?[0-9()-]*$/.test(inputValue))
                        setNewWorkPhone(e.target.value);
                    }}
                    className="p-2"
                    type="tel"
                  />
                  <Button className="bg-slate-300 h-12" onClick={addWorkPhone}>
                    Add
                  </Button>
                </Space.Compact>
                {workPhones?.map((link, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between mt-2 p-2 bg-gray-200 shadow-md rounded-md border border-gray-300"
                  >
                    <Input
                      placeholder="Enter URL"
                      value={link}
                      className="bg-slate-200 mr-2"
                      onChange={(e) => handleWorkPhoneChange(e, index)}
                    />

                    <button
                      type="button"
                      onClick={() => removeWorkPhone(index)}
                    >
                      <img src={deleteicon} alt="" className="w-6 h-6" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
            <div className="w-[100%]">
              <div className="flex flex-col">
                <Space.Compact
                  style={{
                    width: "100%",
                  }}
                >
                  <Input
                    placeholder="Email Address"
                    value={newEmail}
                    id="email"
                    className="p-2"
                    onChange={(e) => setNewEmail(e.target.value)}
                  />
                  <Button className="bg-slate-300  h-12" onClick={addEmail}>
                    Add
                  </Button>
                </Space.Compact>

                {emails?.map((link, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between mt-2 p-2 bg-gray-200 shadow-md rounded-md border border-gray-300"
                  >
                    <Input
                      placeholder="Enter URL"
                      value={link}
                      className="bg-slate-200 mr-2"
                      onChange={(e) => handleEmailChange(e, index)}
                    />

                    <button type="button" onClick={() => removeEmail(index)}>
                      <img src={deleteicon} alt="" className="w-6 h-6" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Contact Person */}
        {/* <ContactPerson
          contactPeople={contactPeople}
          setContactPeople={setContactPeople}
        /> */}

        {/* Button */}
        <div className="flex items-center justify-center">
          <div
            className={`lg:mt-[3rem] flex mt-4 items-center sm:justify-end justify-center sm:w-[70%] w-[80%]`}
          >
            <button
              type="button"
              onClick={() => {
                if (
                  (one || option === "Merchant") &&
                  title &&
                  imageUrl &&
                  firstName &&
                  lastName &&
                  dob &&
                  gender &&
                  nationality &&
                  homePhones.length > 0 &&
                  workPhones.length > 0 &&
                  emails.length > 0
                ) {
                  if (option === "Merchant" && age1 < 16) {
                    setErr("Merchant must be a minimum of 16 years of age");
                    setShow1(true);
                  } else {
                    setMsg(
                      "Please verify that all the details provided are correct. Once submitted you cannot change any information"
                    );

                    setButtonN("Verify Again");
                    setButtonW("Submit");
                    setVerify(true);
                    setShowC(false);
                    setPop("1");
                  }
                } else {
                  if (option === "Employee" && 16 > parseInt(age1)) {
                    setErr("Employee must be a minimum of 16 years of age");
                  } else if (!title) {
                    setErr("Title is not selected");
                  } else if (!imageUrl) {
                    setErr("Image is not selected");
                  } else if (!firstName) {
                    setErr("First Name is not entered");
                  } else if (!lastName) {
                    setErr("Last Name is not entered");
                  } else if (!dob) {
                    setErr("Date of Birth is not entered");
                  } else if (!gender) {
                    setErr("Gender is not selected");
                  } else if (!nationality) {
                    setErr("Nationality is not selected");
                  } else if (homePhones.length === 0) {
                    setErr("Home Phone is not entered");
                  } else if (workPhones.length === 0) {
                    setErr("Work Phone is not entered");
                  } else if (emails.length === 0) {
                    setErr("Email is not entered");
                  }

                  setShow1(true);
                }
              }}
              // onClick={() => dispatch({ type: "IINCREMENT" })}
              className={`lg:text-[1.1rem] bg-gradient-to-tr bg-primary text-white rounded-[0.5rem] p-2  pr-8 pl-8`}
            >
              Next
            </button>
          </div>
        </div>

        <div
          className={`${
            verify ? "" : "hidden"
          } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center`}
        >
          <div className="relative rounded-xl w-[20rem] pb-6 pt-4 flex items-center p-3 bg-white flex-col">
            <div>
              <img src={logo1} alt="" className="w-20 h-20"/>
            </div>
            <p className="text-center mt-[1rem] mb-5">{msg}</p>
            <div className="flex">
              <button
                type="button"
                onClick={() => {
                  setVerify(false);
                }}
                className="cursor-pointer mr-2 rounded-xl pt-[0.5rem] pb-[0.5rem] pl-5 pr-5 text-white bg-[#DE2827]"
              >
                {buttonN}
              </button>

              <button
                type="button"
                onClick={() => {
                  setVerify(false);
                  nextHandler();
                }}
                className={`${
                  pop === "1" ? "" : "hidden"
                } cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-8 pr-8 text-white bg-primary`}
              >
                Submit
              </button>
              <button
                type="button"
                onClick={() => {
                  setVerify(false);
                }}
                className={`${
                  pop === "1" ? "hidden" : ""
                } cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-8 pr-8 text-white bg-primary`}
              >
                {buttonW}
              </button>
            </div>
            <div
              className={`${
                showC ? "" : "hidden"
              } bottom-[-30%] absolute flex items-center p-2 bg-white rounded-2xl`}
            >
              <img className="w-[1.8rem] mr-1" src={logo1} alt="" />
              <p className="font-semibold">Coming Soon</p>
            </div>
          </div>
        </div>
      </form>
      <div
        className={`${
          show ? "" : "hidden"
        } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center`}
      >
        <div className="relative rounded-xl w-[20rem] pb-6 flex items-center p-3 bg-white flex-col">
          <div
            className="absolute top-[-11%] left-[42%]"
            onClick={() => {
              setOne(false);
              setShow(false);
            }}
          >
            <img src={across} alt="" />
          </div>
          <p className="text-center mt-[3rem] mb-5">
            {/* For old age pension program you should be or older than 65 years. */}
          </p>
          <button
            onClick={() => {
              setOne(false);
              setShow(false);
            }}
            className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-[#DE2827] w-[60%]"
          >
            Ok
          </button>
        </div>
      </div>
      <div
        className={`${
          show1 ? "" : "hidden"
        } w-[100%] h-[100%] fixed top-0 left-0 z-10 bg-slate-500/50 flex justify-center items-center`}
      >
        <div className="relative rounded-xl w-[20rem] pb-6 flex items-center p-3 bg-white flex-col">
          <div
            className="absolute top-[-11%] left-[42%]"
            onClick={() => setShow1(false)}
          >
            <img src={across} alt="" />
          </div>
          <p className="text-center mt-[3rem] mb-5">{err}</p>
          <button
            onClick={() => setShow1(false)}
            className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-[#DE2827] w-[60%]"
          >
            Ok
          </button>
        </div>
      </div>
      {faceApi === true && <FaceVerificatioNModal />}
    </div>
  );
};

export default Mid;
